module.exports = __webpack_public_path__ + "static/img/paotuiFee-tips.6c1030c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paotuiFee-tips.jpg
// module id = XLAv
// module chunks = 1